import { VALIDATION_TYPES } from '@exodus/send-validation/src/constants';

export const MINT_ADDRESS_VALIDATION = {
  id: 'ADDRESS_MINT_MISMATCH',
  type: VALIDATION_TYPES.ERROR,
  shouldValidate: ({ asset }) => ['SOLANA_TOKEN'].includes(asset.assetType),

  isValid: ({ asset, addressDetails }) =>
    !addressDetails.targetMint ||
    asset.mintAddress === addressDetails.targetMint,
};
